import type { FormCollectionInput } from "../core/data-forms/form-input-types";

/**
 * Ensures each collection has a valid 'inputs' array.
 * If 'inputs' is not an array, it's replaced with an empty array.
 * Then filters out any collections where 'inputs' is empty.
 */
export function formatCollectionInputs(inputs: FormCollectionInput[]) {
  return inputs
    .map((collection) => ({
      ...collection,
      inputs: Array.isArray(collection.inputs) ? collection.inputs : [],
    }))
    .filter((collection) => collection.inputs.length > 0);
}
